import { render, staticRenderFns } from "./ManageForm9.vue?vue&type=template&id=dd323f10&"
import script from "./ManageForm9.vue?vue&type=script&lang=js&"
export * from "./ManageForm9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports